import { render, staticRenderFns } from "./store-group-aggregations.vue?vue&type=template&id=3ba196d8&scoped=true"
import script from "./store-group-aggregations.vue?vue&type=script&lang=js"
export * from "./store-group-aggregations.vue?vue&type=script&lang=js"
import style0 from "./store-group-aggregations.vue?vue&type=style&index=0&id=3ba196d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba196d8",
  null
  
)

export default component.exports